module.exports = __webpack_public_path__ + "img/DealerIcons-DisplayCreator-Off.ecf8ff7.jpg";